var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulPodcasts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23c-3.033 0-5.5-2.523-5.5-5.625v-9.75C11 4.523 13.467 2 16.5 2S22 4.523 22 7.625v9.75C22 20.477 19.533 23 16.5 23z",
    opacity: 0.158
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 16.813c0-.45-.346-.813-.773-.813-.426 0-.772.364-.772.813 0 4.032-3.12 7.312-6.955 7.312s-6.955-3.28-6.955-7.313c0-.448-.346-.812-.772-.812-.427 0-.773.364-.773.813 0 4.654 3.401 8.488 7.727 8.9v1.662h-3.863c-.427 0-.773.364-.773.813 0 .448.346.812.773.812h9.272c.427 0 .773-.364.773-.813 0-.448-.346-.812-.773-.812h-3.863v-1.662C21.599 25.3 25 21.467 25 16.813z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulPodcasts);
export default __webpack_public_path__ + "static/media/icons-colorful-podcasts.ec8ab422.svg";
export { ForwardRef as ReactComponent };